var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.75,
    height: 296.563,
    viewBox: "0 0 215.75 296.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3083",
    "data-name": "Group 3083",
    transform: "translate(-15701.508 -14515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4493",
    "data-name": "Path 4493",
    d: "M226.705,402.743l15.2,45.226,40.779-88.6-4.078-3.708a4.759,4.759,0,0,0-3.708-1.482c-.742,0-1.112.37-1.854.37l-21.5,8.156-9.268-20.759a5.279,5.279,0,0,0-4.82-3.336l-8.526-.37-41.89,91.193Z",
    transform: "translate(15514.469 14363.594)",
    fill: "#318e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4494",
    "data-name": "Path 4494",
    d: "M413.895,338.61a4.787,4.787,0,0,0-4.82,3.336l-9.268,20.759-21.129-8.156a2.783,2.783,0,0,0-1.854-.37,4.762,4.762,0,0,0-3.708,1.482l-4.078,3.708,40.779,88.6,15.2-45.226,39.294,26.691L422.79,338.239Z",
    transform: "translate(15452.948 14363.595)",
    fill: "#318e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4495",
    "data-name": "Path 4495",
    d: "M312.709,252.087a72.777,72.777,0,0,0,72.658-72.658c0-40.035-32.623-73.029-72.658-73.029s-73.029,32.623-73.029,72.658S272.673,252.087,312.709,252.087Zm-26.691-80.443,17.423,17.423,42.63-42.632,11.491,11.491L303.441,212.05l-28.915-28.915Z",
    transform: "translate(15496.675 14441.963)",
    fill: "#318e0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4496",
    "data-name": "Path 4496",
    d: "M189.28,162.393,201.513,175a10.826,10.826,0,0,1,2.224,11.491l-6.3,16.312,16.312,7.044c3.708,1.482,6.3,5.56,6.671,9.638l.37,17.793,17.793.37a10.622,10.622,0,0,1,9.638,6.3l7.044,16.312,16.681-6.671a10.975,10.975,0,0,1,11.491,2.224l12.976,12.233,12.6-12.233a10.826,10.826,0,0,1,11.491-2.224l16.312,6.671,7.044-16.312a11.039,11.039,0,0,1,9.638-6.3l17.793-.37.37-17.793a10.622,10.622,0,0,1,6.3-9.638l16.312-7.044-6.3-16.312A10.831,10.831,0,0,1,390.2,175l12.233-12.6-12.233-12.6a10.826,10.826,0,0,1-2.224-11.491l6.3-16.681-16.312-7.044a10.616,10.616,0,0,1-6.3-9.638l-.37-17.793-17.793-.37a10.39,10.39,0,0,1-9.638-6.671l-7.411-15.944-16.312,6.671A10.831,10.831,0,0,1,308.648,68.6L295.672,56,282.7,68.234A10.826,10.826,0,0,1,271.2,70.458l-16.312-6.3-7.044,16.312a12.17,12.17,0,0,1-9.638,6.671l-17.793.37-.37,17.793a10.775,10.775,0,0,1-6.671,9.638l-16.312,7.044,6.3,16.681a11.115,11.115,0,0,1-2.224,11.491ZM295.672,84.174a78.219,78.219,0,1,1-78.219,78.219A78.472,78.472,0,0,1,295.672,84.174Z",
    transform: "translate(15513.711 14458.999)",
    fill: "#318e0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.f4451b24d7e66b03294596581c8d9689.svg";
export { ForwardRef as ReactComponent };